// extracted by mini-css-extract-plugin
export default {"footer_container":"tBf68ye800XZfF0RSzFc","footer_wrapper":"OMAdrkRz1bAUXnCtNiBJ","footer_links":"kXrsie9TKiMYXmuZ0Ddo"};